"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _jsxFileName = "/opt/build/repo/plugins/wordsby-master/src/components/Yoast.js";

var _default = function _default(props) {
  return _react.default.createElement(Yoast, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: this
  }));
};

exports.default = _default;

var Yoast = function Yoast(_ref) {
  var yoast = _ref.yoast,
      wpUrl = _ref.wpUrl,
      buildUrl = _ref.buildUrl,
      pagePath = _ref.pagePath;
  if (!yoast || !wpUrl || !buildUrl || !pagePath) return null;
  var canonical_url = yoast.canonical_url,
      og_description = yoast.og_description,
      og_image = yoast.og_image,
      og_title = yoast.og_title,
      seo_metadesc = yoast.seo_metadesc,
      seo_title = yoast.seo_title,
      siteName = yoast.siteName;
  buildUrl = buildUrl ? buildUrl.replace(/\/$/, "") : buildUrl;
  var currentUrl = buildUrl + pagePath; // if there is no canonical URL in yoast, it should be set to the current url

  if (!canonical_url) canonical_url = currentUrl; // replace the WP url with gatsby url if necessary

  if (!!canonical_url && canonical_url.includes(wpUrl)) canonical_url = canonical_url.replace(wpUrl, buildUrl); // still need:
  // og:locale
  // fb:app_id

  return _react.default.createElement(_reactHelmet.Helmet, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    },
    __self: this
  }, !!seo_title && seo_title !== "" && _react.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37
    },
    __self: this
  }, seo_title), !!seo_metadesc && seo_metadesc !== "" && _react.default.createElement("meta", {
    name: "description",
    content: seo_metadesc,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41
    },
    __self: this
  }), !!canonical_url && canonical_url !== "" && _react.default.createElement("link", {
    rel: "canonical",
    href: canonical_url,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46
    },
    __self: this
  }), _react.default.createElement("meta", {
    property: "og:type",
    content: "website",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50
    },
    __self: this
  }), !!og_description && og_description !== "" && _react.default.createElement("meta", {
    property: "og:description",
    content: og_description ? og_description : seo_metadesc,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    },
    __self: this
  }), !!og_image && !!og_image.publicURL && !!buildUrl && _react.default.createElement("meta", {
    property: "og:image",
    content: buildUrl + og_image.publicURL,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60
    },
    __self: this
  }), !!siteName && _react.default.createElement("meta", {
    property: "og:site_name",
    content: siteName,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64
    },
    __self: this
  }), !!currentUrl && _react.default.createElement("meta", {
    property: "og:url",
    content: currentUrl,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67
    },
    __self: this
  }), !!og_title && og_title !== "" && _react.default.createElement("meta", {
    property: "og:title",
    content: og_title ? og_title : seo_title || null,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71
    },
    __self: this
  }), _react.default.createElement("meta", {
    name: "twitter:card",
    content: "summary",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78
    },
    __self: this
  }), !!og_image && !!og_image.publicURL && !!buildUrl && _react.default.createElement("meta", {
    property: "twitter:image",
    content: buildUrl + og_image.publicURL,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82
    },
    __self: this
  }), !!og_title && og_title !== "" && _react.default.createElement("meta", {
    property: "twitter:title",
    content: og_title ? og_title : seo_title,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90
    },
    __self: this
  }));
};